<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4"><i>For Micky Perry, </i></p>
<p class="p4"><i>who qualifies for the following job descriptions:</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Excellent Wife</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Patient and Affectionate Editor </i></p>
<p class="p4"><i>(experienced and qualified)</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>Beacon of Faith </i></p>
<p class="p4"><i>(patience a plus)</i></p>
<p class="p5"><i></i> </p>
<p class="p4"><i>She’s hired. </i></p>
<p class="p4"><i>Position is permanent, </i></p>
<p class="p4"><i>retirement plan included.</i></p>
<p class="p3"><i></i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?6aad5179